export const formatMoney = (value) => {
    const moneyAmount = (value / 100).toFixed(2)

    return new Intl.NumberFormat(window.shopifyData.fullLocale, {
        style: 'currency',
        currency: window.shopifyData.currency.iso_code,
    }).format(moneyAmount)
}
